import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { News } from '../model/news.model';
import { createRequestOption, SearchWithPagination } from '../utils/request-util';
import { ApplicationConfigService } from '../../core/config/application-config.service';



@Injectable({ providedIn: 'root' })
export class NewsService {
    private resourceUrl = "api/news";
    private adminResourceUrl = "api/admin/news";

    constructor(
        private http: HttpClient,
        private applicationConfigService: ApplicationConfigService
    ){}


    query(req?: SearchWithPagination): Observable<HttpResponse<News[]>> {
        const options = createRequestOption(req);
        return this.http.get<News[]>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}`,{params: options, observe: 'response'});
    }

    get(id: number): Observable<News> {
        return this.http.get<News>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/${id}`);
    }

    save(newsToSave: News): Observable<News> {
        return this.http.post<News>(`${this.applicationConfigService.getEndpointFor(this.adminResourceUrl)}`, newsToSave);
    }

    update(newsToUpdate: News): Observable<News> {
        return this.http.put<News>(`${this.applicationConfigService.getEndpointFor(this.adminResourceUrl)}/${newsToUpdate.id!}`, newsToUpdate);
    }
    
    delete(id: number): Observable<HttpResponse<void>> {
        return this.http.delete<void>(`${this.applicationConfigService.getEndpointFor(this.adminResourceUrl)}/${id}`, {observe: 'response'});
    }
}